import { Fragment } from "react";

import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";

import Alert from "ui/base/Alert";
import Page from "ui/Page";

import { useRead, useRefundGift } from "features/article/fabric";
import { useHistory, usePassHistory } from "areas/account/fabric";
import Content from "areas/account/ui/Content";


History.Content = () => {
	const history = useHistory();
	const read = useRead();
	const time = usePassHistory();
	const refund = useRefundGift();
	const theme = useTheme();
	const rows = history.isLoading ? Array.from({ length: history.take }).fill(null) : history.list;

	const style = {
		pagination: { pt: theme.spacing(2) }
	};

	if (!history.isLoading && history.list?.length === 0) return <Typography variant="h4" textAlign="center">Nothing unlocked so far.</Typography>;
	return (
		<>
			<Alert.Error errors={history.mutationError?.errors?.[""]} />
			{rows?.map((content, key, arr) => (
				<Fragment key={key}>
					<Content
						content={content}
						article={read}
						time={time}
						refund={refund}
						action
					/>
					{key + 1 < arr.length && <Divider />}
				</Fragment>
			))}
			{history.pagination && <Pagination siblingCount={0} page={history.pagination?.Page} count={history.pagination?.Pages} onChange={(_, p) => history.updatePage(p)} color="secondary" sx={style.pagination} />}
		</>
	);
};

export default function History() {
	const theme = useTheme();

	const style = {
		body: { mt: theme.spacing(2), gap: theme.spacing(2) }
	};

	return (
		<Page maxWidth="md">
			<Page.Header title="History" subtitle="Recently purchased" />
			<Divider flexItem />
			<Page.Body sx={style.body}>
				<History.Content />
			</Page.Body>
		</Page>
	);
}